<template>
    <img
        src="~/assets/icon/icon-search-color.svg"
        alt=""
    />
</template>
